<section class="d-flex">
    <div class="flex-grow-1 me-2">
        <wdx-ff-subform-info
            [entityId]="entityId"
            [fieldDefinition]="elementDefinition"
            [data]="formControlObj?.value"
            [parentData]="parentData"
            [index]="place"
        >
        </wdx-ff-subform-info>
    </div>
    @if (!readonlyMode) {
        <div class="flex-shrink-0 d-flex align-items-center">
            @if (!disabled && !statusInfo) {
                @if (
                    elementDefinition?.arrayConfiguration?.allowAdd !== false
                ) {
                    <wdx-icon-button
                        wdxStopPropagation
                        data-cy="header-copy-button"
                        wdxStyle="outline-primary"
                        wdxButton
                        [size]="'sm'"
                        [buttonAriaLabel]="
                            'A11Y_FORMS_CLONE_SUBFORM'
                                | translateTokenisedString
                        "
                        (wdxOnClick)="cloneItemClicked()"
                        class="me-1"
                    >
                        <wdx-icon [icon]="UTILS_ICON_COPY"></wdx-icon>
                    </wdx-icon-button>
                }
                @if (
                    elementDefinition?.arrayConfiguration?.allowDelete !== false
                ) {
                    <wdx-icon-button
                        data-cy="header-remove-button"
                        wdxStyle="outline-primary"
                        wdxButton
                        [size]="'sm'"
                        [buttonAriaLabel]="
                            'A11Y_FORMS_REMOVE_SUBFORM'
                                | translateTokenisedString
                        "
                        (wdxOnClick)="removeItemClicked()"
                    >
                        <wdx-icon [icon]="UTILS_ICON_DELETE"></wdx-icon>
                    </wdx-icon-button>
                }
            }

            @if (statusInfo) {
                <wdx-badge themeColor="warning">
                    <wdx-icon [icon]="UTILS_ICON_DANGER"></wdx-icon>
                    {{ statusInfo }}
                </wdx-badge>
            }
        </div>
    }
</section>
